import React, { useEffect, useReducer } from 'react';
import { useQuery, gql } from '@apollo/client';
import { useParams } from 'react-router';
import { Spin } from 'antd';
import ProjectHeader from '../ProjectHeader';
import EditExtension from './EditExtension';
import SubmitExtension from './SubmitExtension';
import PendingExtension from './PendingExtension';
import ResultExtension from './ResultExtension';
import ExtensionSteps from './components/ExtensionSteps';
import ErrorPage from 'components/layout/ErrorPage';
import { PageContainer } from '@ant-design/pro-layout';

const Detail = ({ step, reducer }) => {
  switch (step) {
    case 0:
      return <EditExtension reducer={reducer} />;
    case 1:
      return <SubmitExtension reducer={reducer} />;
    case 2:
      return <PendingExtension reducer={reducer} />;
    case 3:
      return <ResultExtension />;
    default:
      throw new Error();
  }
};
const GET_EXTENSION = gql`
  query extensions($ids: [ID!], $status: [ApplicationStatus!]) {
    extensions(ids: $ids, status: $status) {
      id
      status
    }
  }
`;

const initialState = { step: null };
const reducer = (_state, action) => {
  switch (action.type) {
    case 'APPLY':
      return { step: 0 };
    case 'SUBMIT':
      return { step: 1 };
    case 'APPROVAL':
      return { step: 2 };
    case 'RESULT':
      return { step: 3 };
    default:
      return initialState;
  }
};

const Extension = () => {
  const { id, projectId } = useParams();
  const { data, loading } = useQuery(GET_EXTENSION, {
    variables: {
      ids: [id],
      projectIds: [projectId],
      status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
    },
  });
  const [state, dispatch] = useReducer(reducer, initialState);
  useEffect(() => {
    if (!loading) {
      const status = data.extensions[0]?.status;
      switch (status) {
        case 'DRAFT':
          dispatch({ type: 'SUBMIT' });
          break;
        case 'PENDING':
          dispatch({ type: 'APPROVAL' });
          break;
        case 'APPROVED':
        case 'REJECTED':
        case 'VOIDED':
        default:
          dispatch({ type: 'RESULT' });
          break;
      }
    }
  }, [loading, data]);

  if (loading || state.step === null) {
    return (
      <ProjectHeader>
        <Spin />
      </ProjectHeader>
    );
  }

  if (data.extensions.length === 0) {
    return (
      <ProjectHeader>
        <PageContainer>
          <ErrorPage
            backPage={`/projects/${projectId}/extensions`}
            backButtonText="Back to project's Extensions"
            subTitle="Sorry, the extension you visited does not exist."
          />
        </PageContainer>
      </ProjectHeader>
    );
  }

  return (
    <ProjectHeader>
      <PageContainer>
        <ExtensionSteps current={state.step} />
        <Detail step={state.step} reducer={{ dispatch }} />
      </PageContainer>
    </ProjectHeader>
  );
};

export default Extension;
